<template>
  <a-modal :title="formTitle" :visible="open" width="25%" @cancel="cancel" @ok="submitForm">
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 3 }" :wrapper-col="{ span: 24 }">
      <a-form-model-item label="" prop="name" >
        <a-input v-model="form.name" placeholder="字段名称" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: 'FieldsForm',
  data() {
    return {
      formTitle: '新增字段',
      open: false,
      id: null,
      index: 0,
      form: {
        name: ''
      },
      rules: {
        name: [
          { required: true, message: '字段名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    openModal(id, fields, index) {
      debugger
      this.formTitle = '新增字段'
      this.open = true
      this.reset()
      if (fields) {
        this.form.name = fields
      }
      this.id = id
      this.index = index
    },
    openModal1(id, fields, index) {

      this.formTitle = '编辑字段'
      this.open = true
      this.reset()
      if (fields) {
        this.form.name = fields

      }
      this.id = id
      this.index = index
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    reset() {
      this.form.name = null
      this.id = null
      this.index = 0
    },
    // 修改数据
    change(res) {
      this.$emit('input', '')
      this.$emit('change', res)
    },
    submitForm(value) {
      debugger
      console.log(value)
      console.log(this.form.name)

      this.change({
        name: this.form.name
      })
      this.$emit('ok', { name: this.form.name, index: this.index })
      this.onClose()
      return this.form.name
    }
  }
}
</script>

<style scoped>

</style>